module.exports = __webpack_public_path__ + "img/planeurs.0ef7e3e5.png";